/**
 * Created by xupengwei on 2018/6/26.
 * Modified by heyushuang on 2019/9/26.
 */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhHans from './messages/zh-Hans.i18n';
import enUS from './messages/en-US.i18n';
import util from '../global/util.js';
Vue.use(VueI18n);
export default new VueI18n({
  locale: util.getLan(),
  messages: {
    'zh-hans': zhHans, // 中文语言包
    'en-us': enUS, // 英文语言包
    'zh': zhHans, // 中文语言包
    'en': enUS, // 英文语言包
  }
});



// WEBPACK FOOTER //
// ./src/i18n/index.js